export const vehicleType = [
  { id: '72_72', text: 'Car' },
  { id: '520_520', text: 'Truck Ax2' },
  { id: '527_527', text: 'Truck Ax3' },
  { id: '264_264', text: 'Van' },
] as const;

export default vehicleType;
